import services from './../../services/service'; // Service Class
import validator from './../../services/validator'; // Service
import DashboardHeader from './../Dashboard-Header/index.vue'; // Dashboard Header
import DashboardSidebar from './../Dashboard-Sidebar/index.vue'; // Dashboard Sidebar
import DashboardFooter from './../Dashboard-Footer/index.vue'; // Dashboard Footer
//
import CNdiscountForm from './../../templates/CNdiscountForm/index.vue';
import setts from './../../mixins/setts.js';
let service = new services();
let valid = new validator();
export default {
    name: 'BusinessListings',
    mixins: [setts],
    data () {
        return {
            user: {},
            businesses: {},
            business: {},
            cnsurveys: {},
            cnsurvey: {},
            forums: {},
            reviews: {},
            ratings: {},
            adverts: {},
            citisave: {},
            states: {},
            cities: {},
            quote: {},
            businessCategories: {},
            cndiscount: {},
            cndiscounts:{},
            set_cndiscount:{},
            set_view_cndiscount:false,
            set_update_cndiscount:false,
            panelFlag: false,
            addFlag: false,
            editFlag: false,
            deleteFlag: false,
            cnsurveysPanel: false,
            img_url: service.imageURL,
            working_hours: [],
            business_working_hours: {},
            noBusinessSet: false,
            error_here: {},
            error_count: 0,
            //
            component_view:{},
        }
    },
    components: {
        'component-header': DashboardHeader,
        'component-sidebar': DashboardSidebar,
        'component-footer': DashboardFooter,
        'cndiscount-form': CNdiscountForm
    },
    methods: {
        //settings
        setComponentView(view,attr1,attr2){
            this.component_view = {};
            this.component_view[view] = true;

            //using attr 2 to jump toview
            document.getElementById('discountbazaar').scrollIntoView();
        },

        setPanel(attr,attr2) {
            this.panelFlag = true;
            if(attr == "add"){
                this.editFlag = false;
                this.deleteFlag = false;
                this.addFlag = true;
            }
            if(attr == "edit"){
                this.addFlag = false;
                this.deleteFlag = false;
                this.editFlag = true;
                this.business = attr2;
                this.initMap();
            }
            if(attr == "delete"){
                this.addFlag = false;
                this.editFlag = false;
                this.deleteFlag = true;
                this.business = attr2;
            }
           if(attr == "view-cnsurveys"){
                this.addFlag = false;
                this.editFlag = false;
                this.deleteFlag = false;
                this.cnsurveysPanel = true;
                //this.getBusinessWorkingHours(attr2);
               
            }

        },
        
        isActive(index){
            if(index == 1){
                return "active";
            }
        },
        set_url(link){
            // var res = link.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
            // if(res !== null)
            if((link.includes('http')) || (link.includes('www'))){
                window.location.href = link;
            }else{
                window.location.href = "http://"+link;
            }
        },
        preset() {
            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            } 
           if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.user.user_id = element.user_id;
                        }, this);
                        }else {
                            this.$router.push('login');
                      }
                }).catch((err) => {
                    if(err) {
                     this.$router.push('login');
                    }
                })
            }else {
                this.$router.push('login');
            }
            
        },
        getWorkingHours(){
            this.working_hours = ['12:00 AM', '01:00 AM','02:00 AM','03:00 AM','04:00 AM','06:00 AM','07:00 AM','08:00 AM','09:00 AM','10:00 AM','11:00 AM','12:00 PM','01:00 PM','02:00 PM','03:00 PM','04:00 PM','06:00 PM','07:00 PM','08:00 PM','09:00 PM','10:00 PM','11:00 PM']
        },
        getStates() {
            service.getStates(this).then(function(data) {
                this.states = data.body;
            })
        },

        // getCities(state) {
        //     service.getCities(this, state).then(data => {
        //         this.cities = data.body.data;
        //     })
        // },
 
        // Get cities
        getCities(id) {
            document.getElementById("loader").style.visibility = "visible";
            service.getCities(this, id).then((res) => {
                this.cities = res.body.data;
                document.getElementById("loader").style.visibility = "hidden";
            })
        },
       
       
        //--//settings

        //businesses
        getBusinessCategories() {
            service.getBusinessCategories(this).then(data => {
                if(data.body.status == 200) {
                    this.businessCategories = data.body.data;
                }
            }).catch((err) => {
                if(err) {
                   // toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },
        addBusiness() {
            this.error_count = 0;
            var credentials = {
                business_user: this.user.user_id,
                business_category: this.business.category,
                business_name: this.business.name,
                business_email: this.business.email,
                business_phone: this.business.phone,
                business_address: this.business.address || " ",
                business_state: 15,//this.business.state,
                business_city: 1,//this.business.city,
                business_description: this.business.description || " ",
                business_website: this.business.website || "nill",
                business_facebook: this.business.facebook || 'https://web.facebook.com/',
                business_twitter: this.business.twitter || 'https://twitter.com/',
                business_instagram: this.business.instagram || 'https://www.instagram.com/',
            }

            let navi = this.$router;
            if(credentials.business_user != null && credentials.business_name != null && credentials.business_category != null && credentials.business_email != null && credentials.business_city != null) {
                //validate
                if(!(valid.validateEmail(credentials.business_email))){
                    this.error_here.email = "Invalid Email";
                    this.error_count += 1;
                    this.disable_btn = false;
                    toastr.error('Email is not valid', 'Warning!');
                }
                if(!(valid.validateName(credentials.business_name))){
                    this.error_here.name = "Name is not valid";
                    this.error_count += 1;
                    this.disable_btn = false;
                    toastr.error('Business Name is not valid', 'Warning!');
                }
                if(!(valid.validatePhoneNumber(credentials.business_phone))){
                    this.error_count += 1;
                    this.disable_btn = false;
                    toastr.error('Phone Number is not valid', 'Warning!');
                }
                
                if((credentials.business_website != "nill") && (!(valid.validateWebsite(credentials.business_website)))){
                        this.error_count += 1;
                        this.disable_btn = false;
                        toastr.error('Website is not valid', 'Warning!');
                }

                else if(this.error_count == 0){
                    service.addBusiness(this, credentials).then(data => {
                        if(data.body.status == 201) {
                            toastr.success("Business Added!", "Success!");
                            location.reload(true);
                        }else {
                            toastr.error('Sorry, could not add Business', 'Warning!');
                        }
                    }).catch((err) => {
                        if(err) {
                            toastr.error('Sorry, could not process information', 'Warning!');
                        }
                    })
                }else{
                    //console.log("me")
                    }
            }else {
                toastr.error('Complete all fields with *', 'Warning!');
            }
        },

        getBusinesses() {
            let user_id = localStorage.getItem("cityneeds_token_key");
            service.getBusinesses(this, user_id).then(data => {
               if(data.body.status == 200) {
                    this.businesses = data.body.data;
                    let result = data.body.data;
                    let count = 0;
                    result.forEach(function(element) {
                        ++count;
                        if(count == 1){
                            this.business = element; 
                            this.getCities(this.business.business_state); //populate the city
                        }
                    }, this);
                }else{
                    this.noBusinessSet = true;
                }
            }).catch((err) => {
                if(err) {
                    //-->toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        getBusiness(business) {
            this.panelFlag = false;
            this.cnsurveysPanel = false;
            service.getBusiness(this, business).then(data => {
                if(data.body.status == 200) {
                    this.business = data.body.data;
                    this.getCities(this.business.business_state); //populate the city
                  }
                   
            }).catch((err) => {
                if(err) {
                  //-----  toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        editBusiness() {
            this.error_count = 0;
            if(this.business.business_name != '' && this.business.business_category != '' && this.business.business_phone != '' && this.business.business_city != 0) {
                //validate
                if(!(valid.validateEmail(this.business.business_email))){
                    this.error_here.email = "Invalid Email";
                    this.error_count += 1;
                    this.disable_btn = false;
                    toastr.error('Email is not valid', 'Warning!');
                }
                if(!(valid.validateName(this.business.business_name))){
                    this.error_here.name = "Name is not valid";
                    this.error_count += 1;
                    this.disable_btn = false;
                }
                //scan phone
                this.business.business_phone = this.business.business_phone.toString();
                if(this.business.business_phone.charAt(0)  != "0"){
                    //add leading zero
                    this.business.business_phone = "0"+this.business.business_phone;
                }
                //--continue
                if(!(valid.validatePhoneNumber(this.business.business_phone))){
                    this.error_count += 1;
                    this.disable_btn = false;
                    toastr.error('Phone Number is not valid', 'Warning!');
                }
                if((this.business.business_website != '') && (this.business.business_website != null) && (!(valid.validateWebsite(this.business.business_website)))){
                    this.error_count += 1;
                    this.disable_btn = false;
                    toastr.error('Website is not valid', 'Warning!');
                }

                if(this.error_count == 0){
                    service.editBusiness(this, this.business.business_id, this.business).then(data => {
                        if(data.body.status == 200) {
                            toastr.success("Listing Updated!", "Success!");
                            location.reload(true); 
                        }else {
                            //toastr.error('Sorry, could not update Listing', 'Warning!');
                            location.reload(true);
                        }
                    }).catch((err) => {
                        if(err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                        } 
                    })
                }else {
                    //console.log("me")
                    toastr.error('Please check form for errors in entries', 'Warning!');
                }
            }else {
                toastr.error('Kindly fill all fields', 'Warning!');
                // console.log('11-'+this.business.business_name);
                // console.log('12-'+this.business.business_category);
                // console.log('13-'+this.business.business_phone);
                // console.log('14-'+this.business.business_city);
            }
           
        },

        // getBusinessWorkingHours(b) {
        //     service.getBusinessWorkingHours(this, this.business.business_id).then(data => {
        //         if(data.body.status == 200) {
        //             this.business_working_hours = data.body.data;
        //         }
        //     }).catch((err) => {
        //         if(err) {
        //             toastr.error('Sorry, could not process information', 'Warning!');
        //         }
        //     })
        // },

        setWorkingHours() {
            service.setWorkingHours(this, this.business.business_id, this.business.working_hours).then(data => {
                    if(data.body.status == 200) {
                        toastr.success("Updated!", "Success!");
                        location.reload(true); //vm.$forceUpdate(); -- let vm = new Vue @main.js #check
                    }else {
                        toastr.error('Sorry, could not update Working Hours', 'Warning!');
                    }
                }).catch((err) => {
                    if(err) {
                      toastr.error('Sorry, could not process information', 'Warning!');
                    }
                })
            
        },

        //discounts
        //--addDiscont
        addNewDiscounts() {
            //authen ticate entry
            var payload={
                cndiscount_business: this.business.business_id,
                cndiscount_caption: this.cndiscount.cndiscount_caption,
                cndiscount_description: this.cndiscount.cndiscount_description,
                cndiscount_code: this.cndiscount.cndiscount_code,
                cndiscount_start_date: this.cndiscount.cndiscount_start_date,
                cndiscount_expiry_date: this.cndiscount.cndiscount_expiry_date,
            }
            if(payload.discount_code != ''){
                service.addNewCNdiscount(this, payload).then(data => {
                    if(data.body.status == 201) {
                        toastr.success("Updated!", "Success!");
                        //location.reload(true); //vm.$forceUpdate(); -- let vm = new Vue @main.js #check
                    }else {
                        toastr.error('Sorry, could not process, please check your entries', 'Warning!');
                    }
                }).catch((err) => {
                    if(err) {
                      toastr.error('Sorry, could not process information, please check your entries', 'Warning!');
                    }
                })
            }
            
        },
        //--editDiscont

        //--deleteDiscount

        removeBusiness() {
            service.deleteBusiness(this, this.business.business_id).then(data => {
                    if(data.body.status == 200) {
                        toastr.success("Profile Updated!", "Success!");
                        this.business.business_delete_request = data.body.message;
                       // location.reload(true); 
                    }else {
                        toastr.error('Sorry, could not update Profile', 'Warning!');
                    }
                }).catch((err) => {
                    if(err) {
                      toastr.error('Sorry, could not process information', 'Warning!');
                    }
            })
        },

         //uploads
        onFileChange(e, data) {
            let files = e.target.files || e.dataTransfer.files;
            if (files.length)
            {
                let formData = new FormData();
                formData.append('photo', files[0]); 
                formData.append('data_id', data);
                formData.append('data_type', "businesses");   
                service.uploadDataPhoto(this, formData).then(data => {
                    if(data.body.status == 200){
                        this.business.business_image = data.body.data;
                    }
                  }).catch((err) => {
                    if(err) {
                       // log it
                    }
                })
            }   
            
        },
       //--//uploads
       
       //map-ini
       // Initialize and add the map
        initMap() {  
            // The location of cn
            // const cn = { lat: -25.344, lng: 131.036 };
            const cn = {lat: 8.985714, lng: 7.4465517}
            // The map, centered at cn
            const map = new google.maps.Map(document.getElementById("map"), {
            zoom: 4,
            center: cn,
            });
            // The marker, positioned at cn
            const marker = new google.maps.Marker({
            position: cn,
            map: map,
            });
        },
        
    },
    mounted: function(){
        this.initMap();
    },

    created: function(){
        //this.initMap();
        this.preset();
        this.getStates();
        this.getBusinessCategories();
        this.getBusinesses();
        this.getWorkingHours();
       //
       
    }
}


// WEBPACK FOOTER //
// ./src/components/BusinessListings/script.js